import { Global } from '../states';

const state: Global = {
  emailAsked: false
};

export default state;
